// useNodeContributionHandlers.js

import useNodeContributions from 'node/hooks/useNodeContributions';

export default function useNodeContributionHandlers({
  node,
  user,
  navigate,
  setCurrentNode,
  setCurrentSection,
  contributeParent,
  setContributeOpen,
  setContributeParent,
  setPreSelectedType,
  setCameraOpen,
  setCameraContentType,
  setDefaultNode,
  setEditorSaveMode,
  setInitialChildren,
  setInitialActiveNodeKey,
  setIsUploading,
  photoInputRef,
  videoInputRef,
  documentInputRef,
  filesInputRef,
  onQuickAddRequest,
  onRelatedNodeCreated,
  getChildCreateFields,
}) {
  return useNodeContributions({
    node,
    user,
    navigate,
    setCurrentNode,
    setCurrentSection,
    contributeParent,
    setContributeOpen,
    setContributeParent,
    setPreSelectedType,
    setCameraOpen,
    setCameraContentType,
    setDefaultNode,
    setEditorSaveMode,
    setInitialChildren,
    setInitialActiveNodeKey,
    setIsUploading,
    photoInputRef,
    videoInputRef,
    documentInputRef,
    filesInputRef,
    onQuickAddRequest,
    onRelatedNodeCreated,
    getChildCreateFields,
  });
}
